/**
 * webinarDataUid is needed by the BE to identify the webinar in the form submission
 * to display the correct infos in the success message
 */
export function appendDataUid(
    component: HTMLUxIwsWebinarElement,
    webinarDataUid: string
) {
    const targetInput = Array.from(
        component.querySelectorAll("form input[type='hidden']")
    ).find((el) => {
        // find the input with the additional-info id like "webinarTestform-968533-additionalinfo"
        return /.+-\d+-additionalinfo/.test(el.id);
    }) as HTMLInputElement;
    if (!targetInput) {
        console.error("No additional-info input found");
        return;
    }
    try {
        const jsonContent = JSON.parse(targetInput.value);
        targetInput.value = JSON.stringify({
            ...jsonContent,
            webinarDataUid,
        });
    } catch (e) {
        console.error("Error setting value for additional-info input", e);
    }
}

export function setDateFields(
    component: HTMLUxIwsWebinarElement,
    dateFormat: string,
    date1: string,
    date2: string = ""
) {
    const xPathLabel1 = `//span[text()='Date_1']`;
    const xPathLabel2 = `//span[text()='Date_2']`;
    const date1Label = document.evaluate(
        xPathLabel1,
        component.querySelector("[slot='form']"),
        null,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null
    ).singleNodeValue as HTMLInputElement;
    const date2Label = document.evaluate(
        xPathLabel2,
        component.querySelector("[slot='form']"),
        null,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null
    ).singleNodeValue as HTMLInputElement;
    if (date1Label && date2Label) {
        date1Label.innerHTML = `<ux-date-time utc="${date1}" format="${dateFormat}"></ux-date-time>`;
        date2Label.innerHTML = `<ux-date-time utc="${date2}" format="${dateFormat}"></ux-date-time>`;
    }
    const date1Input = date1Label?.closest("label").querySelector("input");
    const date2Input = date2Label?.closest("label").querySelector("input");
    if (date1Input && date2Input) {
        date1Input.value = date1.toString();
        date2Input.value = date2.toString();
    }
    if (!date2) {
        date1Input.setAttribute("checked", "checked");
        date1Input.closest<HTMLElement>(".powermail_fieldwrap").style.display =
            "none";
    }
}

export function addStylesheet(styleSheet: string) {
    const styleId = "ux-iws-webinar-form-styles";
    if (document.getElementById(styleId)) {
        return;
    }
    const style = document.createElement("link");
    style.id = styleId;
    style.rel = "stylesheet";
    style.href = styleSheet;
    document.head.appendChild(style);
}
